module.exports = __webpack_public_path__ + "static/c_kuu-b997171291917fd5d176d0355b4654c9.jpg";